import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24",
  class: "svg-icon"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  fill: "currentColor",
  d: "M22.718 1.582 19.978 0 15.23 8.221l-2.74-1.582-1.055 1.827 8.221 4.747 1.055-1.827-2.74-1.583 4.746-8.22ZM10.645 9.836l8.221 4.747L18.301 24l-.258-.022-.09-.008c-2.144-.181-4.596-.389-8.928-2.89a22.047 22.047 0 0 1-2.276-1.487c2.03-1.632 3.086-4.135 3.086-4.135s-2.671 1.999-5.273 2.046C3.385 16.03 2.724 14.217 2 12c1.883.254 6.173.153 8.645-2.164Z"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }